import React from 'react';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';

import { RoutesConstants } from './constants';
import MainPage from './pages/MainPage/MainPage';
import RecipesPage from './pages/RecipesPage/RecipesPage';
// import RecipePage from './pages/RecipePage/RecipePage';
import PetruhaOnlinePage from './pages/PetruhaOnlinePage/PetruhaOnlinePage';
import PetruhaPage from './pages/Brands/Petruha/PetruhaPage';
import PetruhaMasterPage from './pages/Brands/PetruhaMaster/PetruhaMasterPage';
import PromotionsPage from './pages/PromotionsPage/PromotionsPage';
// import PromotionPage from './pages/PromotionPage/PromotionPage';
// import PetruhaMasterProductPage from './pages/Brands/PetruhaMaster/PetruhaMasterProductPage';
import PetruhaMKIPage from './pages/Brands/PetruhaMKI/PetruhaMKIPage';
// import PetruhaMKIProductPage from './pages/Brands/PetruhaMKI/PetruhaMKIProductPage';
import PetruhaGotovoPage from './pages/Brands/PetruhaGotovo/PetruhaGotovoPage';
// import PetruhaGotovoProductPage from './pages/Brands/PetruhaGotovo/PetruhaGotovoProductPage';
import ContactsPage from './pages/ContactsPage/ContactsPage';
// import PetruhaProductPage from './pages/Brands/Petruha/PetruhaProductPage';
// import SearchPage from './pages/SearchPage';
// import TestPage from './pages/TestPage';
// import BotPage from './pages/BotPage';
// import ExpertModal from './components/ExpertPage/ExpertModal';
// import PetruhaDailyPage from './pages/PetruhaDailyPage/PetruhaDailyPage';

const PetruhaMKIProductPage = loadable(() => import('./pages/Brands/PetruhaMKI/PetruhaMKIProductPage'));
const PetruhaMasterProductPage = loadable(() => import('./pages/Brands/PetruhaMaster/PetruhaMasterProductPage'));
const PetruhaGotovoProductPage = loadable(() => import('./pages/Brands/PetruhaGotovo/PetruhaGotovoProductPage'));
const PetruhaProductPage = loadable(() => import('./pages/Brands/Petruha/PetruhaProductPage'));
const PetruhaDailyPage = loadable(() => import('./pages/PetruhaDailyPage/PetruhaDailyPage'));
const PromotionPage = loadable(() => import('./pages/PromotionPage/PromotionPage'));

const SearchPage = loadable(() => import('./pages/SearchPage'));
const TestPage = loadable(() => import('./pages/TestPage'));
const BotPage = loadable(() => import('./pages/BotPage'));
const ExpertModal = loadable(() => import('./components/ExpertPage/ExpertModal'));

const RecipePage = loadable(() => import('./pages/RecipePage/RecipePage'));

// eslint-disable-next-line react/prefer-stateless-function
class Main extends React.Component {
  render() {
    const { isMobile } = this.props;

    const domain = window.location.hostname;
    let lang = 'ru';
    switch (domain) {
      case process.env.REACT_APP_DOMAIN_RU:
        lang = 'ru';
        break;
      case process.env.REACT_APP_DOMAIN_BY:
        lang = 'by';
        break;
      case process.env.REACT_APP_DOMAIN_COM:
        lang = 'en';
        break;
      default:
        lang = 'by';
        break;
    }

    return (
      <>
        <svg style={{display: 'none'}}>
          <defs>
            <g id='closer'>
              <path fillRule="evenodd" clipRule="evenodd" d="M4.27295 3.72727C4.27295 2.77333 5.04628 2 6.00022 2C6.95417 2 7.72749 2.77333 7.72749 3.72727V6H4.27295V3.72727ZM2.27295 6L2.27295 3.72727C2.27295 1.66876 3.94171 0 6.00022 0C8.05874 0 9.7275 1.66876 9.7275 3.72727L9.7275 6H10C11.1046 6 12 6.89543 12 8V13C12 14.1046 11.1046 15 10 15L2 15C0.895431 15 0 14.1046 0 13L0 8C0 6.89543 0.895431 6 2 6H2.27295Z" fill="#7F8190"/>
            </g>
            <g id='snow'>
              <path d="M16.4899 13.3643L14.5601 12.2502L16.2324 11.264C16.5409 11.0822 16.6435 10.6847 16.4616 10.3762C16.2797 10.0678 15.8823 9.96523 15.5738 10.147L13.2701 11.5054L9.7966 9.49996L13.2695 7.49484L15.5739 8.85305C15.6772 8.914 15.7906 8.94287 15.9025 8.94287C16.1245 8.94287 16.3407 8.82876 16.4616 8.62362C16.6434 8.31516 16.5407 7.91767 16.2323 7.73578L14.5596 6.74999L16.4899 5.63557C16.8 5.45653 16.9062 5.05999 16.7272 4.74989C16.5481 4.43971 16.1516 4.33346 15.8415 4.51259L13.9117 5.62684L13.8941 3.68509C13.8909 3.32702 13.5972 3.03767 13.24 3.0426C12.8819 3.0458 12.5942 3.33869 12.5975 3.69676L12.6216 6.3716L9.14831 8.37698V4.36657L11.477 3.05046C11.7887 2.87428 11.8986 2.47877 11.7224 2.16695C11.5463 1.85521 11.1507 1.74525 10.8389 1.92152L9.14831 2.87705V0.648373C9.14831 0.290298 8.85801 0 8.49994 0C8.14186 0 7.85156 0.290298 7.85156 0.648373V2.87705L6.16095 1.9216C5.84904 1.74533 5.45371 1.85521 5.27744 2.16703C5.10125 2.47877 5.21113 2.87437 5.52287 3.05055L7.85148 4.36666V8.37698L4.37819 6.3716L4.40231 3.69676C4.40559 3.33869 4.11789 3.0458 3.75981 3.0426C3.75782 3.0426 3.75592 3.0426 3.75385 3.0426C3.39854 3.0426 3.10885 3.329 3.10565 3.68518L3.0881 5.62684L1.15828 4.51259C0.848187 4.33346 0.451642 4.4398 0.272605 4.74989C0.0935677 5.05999 0.199814 5.45653 0.509909 5.63557L2.44007 6.74999L0.767184 7.73595C0.458731 7.91775 0.356029 8.31525 0.537833 8.62379C0.658776 8.82893 0.874987 8.94305 1.09708 8.94305C1.20894 8.94305 1.32228 8.91409 1.42567 8.85323L3.73033 7.49502L7.20328 9.50013L3.72973 11.5056L1.42567 10.1469C1.11739 9.96514 0.719723 10.0677 0.537833 10.3761C0.355943 10.6846 0.458558 11.0821 0.767011 11.2639L2.43964 12.2501L0.509823 13.3643C0.199728 13.5433 0.0934812 13.9398 0.272519 14.2499C0.392597 14.4579 0.610537 14.5742 0.834615 14.5742C0.944579 14.5742 1.0561 14.5462 1.1582 14.4872L3.08801 13.373L3.10556 15.3148C3.10876 15.6709 3.39845 15.9574 3.75376 15.9574C3.75575 15.9574 3.75774 15.9574 3.75973 15.9573C4.1178 15.9541 4.40551 15.6612 4.40222 15.3032L4.3781 12.6282L7.85148 10.6229V14.6333L5.52287 15.9494C5.21113 16.1256 5.10125 16.5211 5.27744 16.833C5.39665 17.0439 5.61632 17.1624 5.84247 17.1624C5.95053 17.1624 6.06015 17.1354 6.16095 17.0784L7.85156 16.123V18.3516C7.85156 18.7097 8.14186 19 8.49994 19C8.85801 19 9.14831 18.7097 9.14831 18.3516V16.123L10.8389 17.0784C10.9397 17.1354 11.0493 17.1624 11.1574 17.1624C11.3836 17.1624 11.6032 17.0439 11.7224 16.833C11.8986 16.5212 11.7887 16.1256 11.477 15.9494L9.14831 14.6333V10.6229L12.6216 12.6282L12.5969 15.3031C12.5935 15.6611 12.8811 15.9541 13.2392 15.9574C13.2413 15.9575 13.2433 15.9575 13.2453 15.9575C13.6006 15.9575 13.8902 15.6711 13.8935 15.3151L13.9115 13.373L15.8416 14.4873C15.9437 14.5463 16.0552 14.5743 16.1652 14.5743C16.3892 14.5743 16.6072 14.4579 16.7273 14.25C16.9063 13.9399 16.8001 13.5434 16.4899 13.3643Z" fill="#5CB0EC"/>
            </g>
            <g id='termometr'>
              <path fillRule="evenodd" clipRule="evenodd" d="M4.83716 1.06394C3.94666 1.06394 3.22477 1.77845 3.22477 2.65986V10.2743L2.95643 10.428C1.8305 11.0726 1.07492 12.2763 1.07492 13.6539C1.07492 15.7105 2.75933 17.3777 4.83716 17.3777C6.91499 17.3777 8.59939 15.7105 8.59939 13.6539C8.59939 12.2763 7.84382 11.0726 6.71788 10.428L6.44954 10.2743V2.65986C6.44954 1.77845 5.72766 1.06394 4.83716 1.06394ZM2.14985 2.65986C2.14985 1.19085 3.35299 0 4.83716 0C6.32132 0 7.52447 1.19085 7.52447 2.65986V9.67249C8.81985 10.5307 9.67432 11.9933 9.67432 13.6539C9.67432 16.2981 7.50866 18.4417 4.83716 18.4417C2.16566 18.4417 0 16.2981 0 13.6539C0 11.9933 0.854465 10.5307 2.14985 9.67249V2.65986Z" fill="#4BAF51"/>
              <path d="M4.83688 6.04651C4.50293 6.04651 4.23224 6.30497 4.23224 6.6238V12.0533C3.52769 12.291 3.02295 12.9325 3.02295 13.6866C3.02295 14.6431 3.83507 15.4185 4.83688 15.4185C5.8387 15.4185 6.65082 14.6431 6.65082 13.6866C6.65082 12.9325 6.14607 12.291 5.44153 12.0533V6.6238C5.44153 6.30497 5.17083 6.04651 4.83688 6.04651Z" fill="#4BAF51"/>
            </g>
          </defs>
        </svg>
        <div>
          <main>
            <Switch>
              <Route
                exact
                path={RoutesConstants.MAIN_PAGE_ROUTE}
                render={(props) => (
                  <MainPage isMobile={isMobile} lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.RECIPES_PAGE_ROUTE}
                render={(props) => (
                  <RecipesPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.RECIPE_PAGE_ROUTE}
                render={(props) => (
                  <RecipePage lang={lang} {...props} />
                )}
              />
              <Route
                path={RoutesConstants.PETRUHA_ONLINE_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaOnlinePage lang={lang} {...props} />
                )}
              />
              {/* <Suspense fallback={<div>Loading...</div>}> */}
              <Route
                exact
                path={RoutesConstants.DAILY_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaDailyPage lang={lang} isMobile={isMobile} {...props} />
                )}
              />
              {/* </Suspense> */}
              <Route
                exact
                path={RoutesConstants.BRANDS_PETRUHA_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.PETRUHA_PRODUCTS_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaProductPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.BRANDS_PETRUHA_MASTER_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaMasterPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.PETRUHA_MASTER_PRODUCTS_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaMasterProductPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.BRANDS_PETRUHA_MKI_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaMKIPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.PETRUHA_MKI_PRODUCTS_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaMKIProductPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.BRANDS_PETRUHA_GOTOVO_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaGotovoPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.PETRUHA_GOTOVO_PRODUCTS_PAGE_ROUTE}
                render={(props) => (
                  <PetruhaGotovoProductPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.PROMOTIONS_PAGE_ROUTE}
                render={(props) => (
                  <PromotionsPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.PROMOTION_PAGE_ROUTE}
                render={(props) => (
                  <PromotionPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.CONTACTS_PAGE_ROUTE}
                render={(props) => (
                  <ContactsPage lang={lang} isMobile={isMobile} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.SEARCH_PAGE_ROUTE}
                render={(props) => (
                  <SearchPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.TEST_PAGE_ROUTE}
                render={(props) => (
                  <TestPage lang={lang} {...props} />
                )}
              />
              <Route
                exact
                path={RoutesConstants.BOT_PAGE}
                render={(props) => (
                  <BotPage lang={lang} {...props} />
                )}
              />
              {
                this.isMobile && (
                  <Route
                    exact
                    path={RoutesConstants.EXPERT_PAGE_ROUTE}
                    render={() => (
                      <ExpertModal />
                    )}
                  />
                )
              }
            </Switch>
          </main>
        </div>
      </>
    );
  }
}

export default connect((state) => ({
  isMobile: state.ResizeReducer.isMobile,
}))((withRouter(Main)));
